import { platformSchema, type Platform } from "@/schemas/skopa/platformSchema";
import { formOptions, revalidateLogic } from "@tanstack/react-form";

export const defaultValues: Platform = {
  platformId: "",
  name: "",
  type: "BATTLESHIP",
  status: "STANDBY",
  mobility: "SEA",
  position: {
    longitude: 0,
    latitude: 0,
  },
  headingDeg: 0,
  elevationM: 0,
  enableGps: false,
  silos: [
    {
      siloId: "",
      status: "STANDBY",
      capacity: 6,
      currentInventory: 6,
      zone: "CENTER",
    },
  ],
};

export const skopaPlatformFormOptions = formOptions({
  defaultValues,
  validators: {
    onSubmit: platformSchema,
  },

  validationLogic: revalidateLogic({
    mode: "submit",
    modeAfterSubmission: "change",
  }),
});
